import { h, Component } from 'preact';
import { bind, memoize, debounce } from 'decko';
import Select from 'preact-material-components/Select';
import TextField from 'preact-material-components/TextField';
import Menu from 'preact-material-components/Menu';
import Button from 'preact-material-components/Button';
import { IRegisterState, RegisterStatus } from './IRegister';
import { RegisterModel } from '../../models/RegisterModel';
import { TextValue } from '../../models/TextValue';
import { CountryInfo } from '../../models/CountryInfo';
import { CountrySelect } from '../../components/countrySelect/countrySelect';
import { BaseComponent } from '../../common/BaseComponent';
import { route } from 'preact-router';
import { UserTypeEnum } from '../../enums/UserTypeEnum';
import { BuildingSigninOptions } from '../../models/BuildingSigninOptions';

let style = require('./style.scss');

export class Register extends BaseComponent<any, IRegisterState> {
    public country: CountryInfo;

    public buildingOptions: BuildingSigninOptions;

    public refs: {
        firstName: TextField,
        lastName: TextField,
        email: TextField,
        companyName: TextField,
    };

    constructor(props: any, ctx) {
        super(props, ctx);
        this.setState({
            mode: props.mode,
            model: new RegisterModel({ country: 'au', countryPrefix: '+61', mobile: '+61' }),
            countries: [
                { shortCode: 'au', name: 'Australia', prefix: '+61' },
                { shortCode: 'nz', name: 'New Zealand', prefix: '+64' },
                { shortCode: 'za', name: 'South Africa', prefix: '+27' },
                { shortCode: 'gb', name: 'United Kingdom', prefix: '+44' },
                { shortCode: 'us', name: 'United States', prefix: '+1' },
                { shortCode: 'sg', name: 'Singapore', prefix: '+65' },
                { shortCode: 'hk', name: 'Hong Kong', prefix: '+852' },
                { shortCode: 'fj', name: 'Fiji', prefix: '+679' }
            ]
            , isValid: false
            , isMobileValid:false
        });
        if (props.withOptions) {
            history.replaceState(null, "myBuildings Sign In", "/register");
            this.buildingOptions = JSON.parse(localStorage["buildingOptions"]);
            if (this.buildingOptions.allowContractors && !this.buildingOptions.allowTenants && !this.buildingOptions.allowVisitors) {
                this.onSetUserType(UserTypeEnum.Contractor);
            } else if (this.buildingOptions.allowTenants && !this.buildingOptions.allowContractors && !this.buildingOptions.allowVisitors) {
                this.onSetUserType(UserTypeEnum.Tenant);
            } if (this.buildingOptions.allowVisitors && !this.buildingOptions.allowContractors && !this.buildingOptions.allowTenants) {
                this.onSetUserType(UserTypeEnum.Visitor);
            }
        }
        console.log("buildingOptions", this.buildingOptions);
    }

    @bind
    public onChangeModel(field: string, value: any) {
        this.setState((s: IRegisterState) => {
            s.model[field] = value;
            s.isValid = this.isValid(s.model);
            return s;
        });
    }

    @bind
    public onChangeCountry(c: CountryInfo) {
        this.country = c;
        var value = this.country ? this.country.shortCode : undefined;
        this.setState((s: IRegisterState) => {
            s.model.country = value;
            s.model.countryPrefix = this.country ? this.country.prefix : undefined;
            s.model.mobile = this.country ? this.country.prefix : undefined;
            s.isValid = this.isValid(s.model);
            return s;
        });
    }

    @bind
    public onChangeMobile(mobile: string) {

        var regex = "^\\" + this.state.model.countryPrefix + "[0-9]{0,10}$";
        if (this.state.model.country == 'au')
            regex = "^\\" + this.state.model.countryPrefix + "(?:4|$)[0-9]{0,8}$";
        if (this.state.model.country == 'nz')
            regex = "^\\" + this.state.model.countryPrefix + "(?:2|$)[0-9]{0,9}$";
        if (!mobile.match(regex)) {
            mobile = this.state.model.mobile;
        }
        this.setState((s: IRegisterState) => {
            s.model.mobile = mobile;
            s.isValid = this.isValid(s.model);
            s.isMobileValid = this.isMobileValid(s.model);
            return s;
        });
    }

    private isMobileValid(m: RegisterModel): boolean {
        var regex = "^\\" + this.state.model.countryPrefix + "[0-9]{1,10}$";
        if (this.state.model.country == 'au')
            regex = "^\\" + this.state.model.countryPrefix + "4[0-9]{8}$";
        if (this.state.model.country == 'nz')
            regex = "^\\" + this.state.model.countryPrefix + "2[0-9]{7,9}$";

        if (!m.mobile || !m.mobile.match(regex))
            return false;
        return true;
    }

    private isValid(m: RegisterModel): boolean {
        return !!(m.country && m.mobile && m.firstName && m.lastName && (this.state.mode != "companyName" && m.companyCode || this.state.mode == "companyName" && m.companyName || this.state.model.userType !== UserTypeEnum.Contractor && m.companyName || this.state.mode == "update") && (m.email || this.state.model.userType !== UserTypeEnum.Contractor));
    }

    @bind 
    public onRegister() {
        this.modal.showLoader(this.state.model.userType == UserTypeEnum.Contractor ? this.authService.registerContractor(this.state.model) : this.authService.registerOther(this.state.model))
        .then(r => {
            if (r.errorMessage) {
                this.modal.alert(r.errorMessage);
                return;
            }
            localStorage.removeItem("buildingOptions");
            this.login(r.result);
        }).catch(e => {
            this.modal.alert(e.errorMessage || e);
        });
    }

    @bind
    public onRegisterOrUpdate() {
        if (this.state.mode != "update") {
            return this.onRegister();
        }

        this.modal.showLoader(this.authService.updateUserDetails(this.state.model))
            .then(r => {
                if (r.errorMessage) {
                    this.modal.alert(r.errorMessage);
                    return;
                }
                if (r.infoMessage) {
                    this.modal.alert(r.infoMessage);
                }
            }).catch(e => {
                this.modal.alert(e.errorMessage || e);
            });
    }

    @bind
    public onSendOtp() {
        if (this.state.model.userType == UserTypeEnum.Contractor) {
            var buildingId = '';
            var returnUrl = localStorage.getItem("returnUrl");
            if (returnUrl) { 
                var match = returnUrl.toUpperCase().match("([0-9,A-F]{8}-[0-9,A-F]{4}-[0-9,A-F]{4}-[0-9,A-F]{4}-[0-9,A-F]{12}(?:/.*)?)$");
                if (match && match.length >= 2) {
                    buildingId = match[1];
                }
            }

            this.modal.showLoader(this.authService.sendOtp({ mobileNumber: this.state.model.mobile, buildingId: buildingId }))
                .then(t => {
                    if (t.errorMessage) {
                        this.modal.alert(t.errorMessage);
                        return;
                    }
                    this.auth.setToken(t.result, 300);
                    this.setState({ status: RegisterStatus.ConfirmNumber });
                }).catch(e => {
                    this.modal.alert(e.errorMessage || e);
                });
        }
        else {
            this.setState({ status: RegisterStatus.Register });
        }
    }

    private login(t: string) {
        this.auth.setToken(t, 126144000);
        //this.refs.bar.MDComponent.show({ message: "Success" });
        var url = localStorage.getItem("returnUrl");
        if (url)
            localStorage.removeItem("returnUrl");
        else
            url = "/";
        route(url,true);
    }

    @bind
    public onConfirm() {
        if (!this.state.model.otpCode)
            return;
        this.modal.showLoader(this.authService.verifyOtp({ mobile: this.state.model.mobile, otpCode: this.state.model.otpCode }))
            .then(r => {
                if (r.errorMessage) {
                    this.modal.alert(r.errorMessage);
                    return;
                }
                if (r.result) {
                    this.login(r.result);
                } else {
                    this.setState({ status: RegisterStatus.Register });
                }
            }).catch(e => {
                this.modal.alert(e.errorMessage || e);
            });
    }

    @bind
    public onSetUserType(userType: UserTypeEnum) {
        this.setState({ model: { ...this.state.model, userType: userType }, status: RegisterStatus.EnterPhone });
    }

    componentWillReceiveProps(p) {
        this.setState({ mode: p.mode });
    }

    componentDidMount() {
        if (this.auth.isAuthenticated() && this.auth.hasAnyRoles(["ApiAccess"]) && this.state.mode != "update") {
            route("/", true);
            return;
        }
        if (this.state.mode == "update") {

            this.modal.showLoader(this.authService.checkUserStatus())
                .then(r => {
                    this.commonService.setHeaderImage(r.result.useHeaderImage);
                    this.commonService.setFooterImage(r.result.useFooterImage);
                    this.setState((s: IRegisterState) => {
                        s.model.firstName = r.result.userFirstName;
                        s.model.lastName = r.result.userLastName;
                        s.model.email = r.result.userEmail;
                        s.model.companyName = r.result.userCompanyName;
                        return s;
                    });
                    (this.refs.firstName.MDComponent as any).label_.float(r.result.userFirstName);
                    (this.refs.lastName.MDComponent as any).label_.float(r.result.userLastName);
                    (this.refs.companyName.MDComponent as any).label_.float(r.result.userCompanyName);
                    (this.refs.email.MDComponent as any).label_.float(r.result.userEmail);
                    this.setState({ isValid: this.isValid(this.state.model) });
                }).catch(e => {
                    //this.modal.alert(e.errorMessage || e);
                });;
        }
    }

    render() {
        return <div>
            {this.state.mode !== "update" &&
                <div class="text-center"><br /></div>}
            { this.renderRegister() }
              </div >
    }

    renderRegister() {
        if (this.state.status == RegisterStatus.ConfirmNumber)
            return (
                <div class={style.confirm}>
                    <br />
                    <div class="text-center">A Registration PIN has been sent <br />via SMS to {this.state.model.mobile}
                    <br />
                    <br />If this number is incorrect, please <a href="#" onClick={() => { this.setState({ status: RegisterStatus.EnterPhone }) }}>click here</a></div>
                    <br />
                    <div class={`${style.formField}`}>
                        <TextField required name="confirmCode" type="number" id="confirmCode" label='Enter PIN received by SMS' value={this.state.model.otpCode} onInput={(e: any) => this.onChangeModel('otpCode', e.target.value)}></TextField>
                    </div>
                    <div class={`${style.formField}`}>
                        <Button disabled={!this.state.model.otpCode} raised ripple onClick={this.onConfirm}>Confirm</Button>
                    </div>
                </div>
            );
        else if (this.state.status == RegisterStatus.Register || this.state.mode == "update") {
            return (
                <div class={style.register}>

                    {this.state.mode != "update" && <div class={`${style.formField}`}>
                        {this.state.model.userType == UserTypeEnum.Contractor && <h4 class="text-center">Please complete your details to register <br /></h4>}
                        {this.state.model.userType !== UserTypeEnum.Contractor && <h4 class="text-center">Please complete the following details to sign in<br /></h4>}
                        {this.state.model.userType == UserTypeEnum.Contractor && <h4 class="text-center">
                            If you have been provided with a <br />
                            Contractor Company Code, enter it <br />
                            so that you can access work <br />
                            requests from your company</h4>}
                    </div>}
                    <div class={`${style.formField}`}>
                        <TextField ref={this.setRef("firstName")} required={true} id="firstName" name="firstName" label='First Name' value={this.state.model.firstName} onInput={(e: any) => this.onChangeModel('firstName', e.target.value)}></TextField>
                    </div>
                    <div class={`${style.formField}`}>
                        <TextField ref={this.setRef("lastName")} required={true} id="lastName" name="lastName" label='Last Name' value={this.state.model.lastName} onInput={(e: any) => this.onChangeModel('lastName', e.target.value)}></TextField>
                    </div>
                    <div class={`${style.formField}`}>
                        <TextField ref={this.setRef("email")} required={this.state.model.userType == UserTypeEnum.Contractor} id="email" name="email" label='Email' value={this.state.model.email} onInput={(e: any) => this.onChangeModel('email', e.target.value)}></TextField>
                    </div>
                    {(this.state.mode == "companyName" || this.state.mode == "update" || this.state.model.userType !== UserTypeEnum.Contractor) && <div class={`${style.formField}`}>
                        <TextField ref={this.setRef("companyName")} required={this.state.mode != "update"} id="companyName" name="companyName" label='Company Name' value={this.state.model.companyName} onInput={(e: any) => this.onChangeModel('companyName', e.target.value)}></TextField>
                        {this.state.mode != "update" && this.state.model.userType == UserTypeEnum.Contractor &&
                            <span><br /><a href="#" onClick={() => { this.setState((s: IRegisterState) => { s.mode = ""; s.model.companyName = undefined; return s; }, () => { this.setState({ isValid: this.isValid(this.state.model) }); }) }}>Enter Contractor Company Code</a><br /><br /> </span>}
                    </div>}
                    {this.state.mode != "update" && this.state.mode != "companyName" && this.state.model.userType == UserTypeEnum.Contractor && <div class={`${style.formField}`}>
                        <TextField ref={this.setRef("companyCode")} id="companyCode" name="companyCode" required={true} label='Contractor Company Code' value={this.state.model.companyCode} onInput={(e: any) => this.onChangeModel('companyCode', e.target.value)}></TextField>
                        <br /><a href="#" onClick={() => { this.modal.confirmation('It is highly recommended to enter a contractor company code if you are performing works onsite, in order to view associated work orders and documentation.    \r\n\r\nPress OK to instead enter your company name (with limited functionality), or press Cancel to enter a contractor company code', () => { this.setState((s: IRegisterState) => { s.mode = "companyName"; s.model.companyCode = undefined; return s; }, () => { this.setState({ isValid: this.isValid(this.state.model) }); }); }, 'OK', () => { }, 'Cancel'); }}>I don’t have a contractor company code</a><br /><br />
                    </div>}
                    <div class={`${style.formField}`}>
                        <Button raised ripple disabled={!this.state.isValid} onClick={this.onRegisterOrUpdate}>{this.state.mode != "update" ? "Continue" : "Save"}</Button>
                    </div>
                </div>

            );
        }
        else if (this.state.status == RegisterStatus.EnterPhone)
            return (
                <div class={style.register}>
                    <div class={`${style.formField}`}>
                        Please provide your Phone Number
                    </div>
                    <div class={`${style.formField}`}>
                        <CountrySelect countries={this.state.countries} onSelect={this.onChangeCountry} />
                    </div>
                    <div class={`${style.formField}`}>
                        <TextField required={true} id="mobile" name="mobile" label='Mobile Number' value={this.state.model.mobile} onInput={(e: any) => this.onChangeMobile(e.target.value)}></TextField>
                    </div>
                    <div class={`${style.formField}`}>
                        <Button raised ripple disabled={!this.state.isMobileValid} onClick={this.onSendOtp}>Continue</Button>
                    </div>
                </div>

            );
        else
            return (
                <div class={style.register}>
                    <h2 class="text-center">Sign In</h2>
                    <div class="text-center"><p>Please specify which type of visitor you are.</p>
                    </div>
                    <div class={`${style.formField} ${style.userType}`}>
                        {(!this.props.withOptions || this.buildingOptions.allowContractors) && <Button raised ripple onClick={() => { this.onSetUserType(UserTypeEnum.Contractor) }}>Contractor</Button>}
                    </div>
                    <div class={`${style.formField} ${style.userType}`}>
                        {(!this.props.withOptions || this.buildingOptions.allowVisitors) && <Button raised ripple onClick={() => { this.onSetUserType(UserTypeEnum.Visitor) }}>Visitor</Button>}
                    </div>
                    <div class={`${style.formField} ${style.userType}`}>
                        {(!this.props.withOptions || this.buildingOptions.allowTenants) && <Button raised ripple onClick={() => { this.onSetUserType(UserTypeEnum.Tenant) }}>Tenant</Button>}
                    </div>
                </div>
            );
    }
}



// WEBPACK FOOTER //
// ./routes/register/register.tsx